import Vue from "vue";
import Vuex from "vuex";
import EgauImg from "@/assets/img/tn/egau_tn.jpg";
import tbslImg from "@/assets/img/tn/tbsl-tn.jpg";
// import nzImg from "@/assets/img/tn/jaru-nz.jpg";
// import NBImg from "@/assets/img/tn/NilsBuri-thumbnail.jpg";
// import friseImg from "@/assets/img/tn/frise-tn.jpg";
import chempaeImg from "@/assets/img/tn/chempae-tn.jpg";
// import sdImg from "@/assets/img/tn/sd-tn.jpg";
import ozsImg from "@/assets/img/tn/ozs-tn2.jpg";
import mnImg from "@/assets/img/tn/mn-tn.jpg";
// import wmImg from "@/assets/img/tn/workmed-tn.jpg";
import nkImg from "@/assets/img/tn/nachklang_tn-4.png";
import kdImg from "@/assets/img/tn/khodor-tn.jpg";
import skImg from "@/assets/img/tn/souk-tn.jpg";
import wngImg from "@/assets/img/tn/WOHNIG-tn.jpg";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    projects: [],
    selectedType: 'Alle',

    imprint: [
      {
        title: "Inhaltliche Verantwortung",
        content:
          '<strong>Jonas Kunz e.U.</strong><br>Kirchlindachstrasse 15<br>3052 Zollikofen<br><br><a href="mailto:web@jouns.ch">web@jouns.ch</a><br><br>CHE-411.013.552'
      },
      {
        subSections: [
          {
            title: "Copyright",
            content:
              "Die Urheber- und alle anderen Rechte an Inhalten wie Bilder, Illustrationen, Videos wie auch Texte oder andere Inhalte auf dieser Website, gehören ausschliesslich Jonas Kunz oder den speziell genannten Rechteinhabern. Für die Reproduktion jeglicher Inhalte ist die schriftliche Zustimmung des Urheberrechtsträgers im Voraus einzuholen."
          }
        ],
        title: "Disclaimer",
        content:
          "Alle Texte und Links wurden sorgfältig geprüft und werden laufend aktualisiert. Jedoch übernimmt der Autor keinerlei Verantwortung, Garantien oder Haftung dafür, dass die durch diese Website bereitgestellten Informationen, richtig, vollständig oder aktuell sind. Der Autor behält sich das Recht vor, jederzeit und ohne Vorankündigung die Informationen auf dieser Website zu ändern und verpflichtet sich auch nicht, die enthaltenen Informationen zu aktualisieren. Alle Links zu externen Anbietern wurden zum Zeitpunkt ihrer Aufnahme auf ihre Richtigkeit überprüft, dennoch haftet der Autor nicht für Inhalte und Verfügbarkeit von Websites, die mittels Hyperlinks zu erreichen sind. Für illegale, fehlerhafte oder unvollständige Inhalte und insbesondere für Schäden, die durch Inhalte verknüpfter Seiten entstehen, haftet allein der Anbieter der Seite, auf welche verwiesen wurde. Dabei ist es gleichgültig, ob der Schaden direkter, indirekter oder finanzieller Natur ist oder ein sonstiger Schaden vorliegt, der sich aus Datenverlust, Nutzungsausfall oder anderen Gründen aller Art ergeben könnte.",
      },
      {
        title: "Datenschutz",
        content:
          "Für die Sicherheit der Datenübertragung im Internet können wir keine Gewähr übernehmen, insbesondere besteht bei der Übertragung von Daten per E-Mail die Gefahr des Zugriffs durch Dritte.<br>Einer Nutzung der im Impressum veröffentlichten Kontaktdaten durch Dritte zu Werbezwecken wird hiermit ausdrücklich widersprochen. Der Betreiber behält sich für den Fall unverlangt zugesandter Werbe- oder Informationsmaterialien ausdrücklich rechtliche Schritte vor.<br>Sollten einzelne Regelungen oder Formulierungen dieses Haftungsausschlusses unwirksam sein oder werden, bleiben die übrigen Regelungen in ihrem Inhalt und ihrer Gültigkeit hiervon unberührt.",
        subSections: [
          {
            title: "Adobe Fonts",
            content:
              'Wir setzen auf unserer Website Adobe Fonts zur visuellen Gestaltung ein. Adobe Fonts ist ein Dienst der Adobe Systems Incorporated, 345 Park Avenue, San Jose, CA 95110-2704, USA (Adobe), der uns den Zugriff auf eine Schriftartenbibliothek gewährt. Zur Einbindung der von uns benutzten Schriftarten, muss dein Browser eine Verbindung zu einem Server von Adobe in den USA aufbauen und die für unsere Website benötigte Schriftart herunterladen. Adobe erhält hierdurch die Information, dass von Ihrer IP-Adresse unsere Website aufgerufen wurde. Weitere Informationen zu Adobe Fonts, finden Sie in der Datenschutzerklärung von Adobe, welche du unter folgendem Link findest: <a href="https://www.adobe.com/ch_de/privacy/policies/adobe-fonts.html" target="_blank">Adobe Fonts Datenschutzerklärung</a>'
          }
        ]
      }
    ]
  },
  getters: {
    filteredProjects(state) {
      console.log('Filter aktiv:', state.selectedType);
      if (state.selectedType === 'Alle') {
        return state.projects;
      }
      const result = state.projects.filter(
        project => project.type === state.selectedType
      );
      console.log('Gefilterte Projekte:', result); // <--- Füge das ein
      return result;
    }
  },


  mutations: {
    setProjects(state, projects) {
      state.projects = projects;
    },
    setSelectedType(state, type) {
      console.log("Mutation wird aufgerufen mit:", type); // ← hinzufügen!
      state.selectedType = type;
    },
  },


  actions: {
    initProjects({ commit }) {
      const initialProjects = [
        {
          image: wngImg,
          title: "WOHNIG",
          year: 2026,
          type: "Musikvideo",
          by: "Motelpool",
          myroll: "Regie & Schnitt",
          rolls: [
            { title: "Regie & Schnitt", name: "<a href='/about'><hl>Jonas Kunz</hl></a>" },
            { title: "Kamera", name: "<a target='_blank' rel='noopener noreferrer' href='https://mauricebusch.ch'>Maurice Busch<a><br><br>" },
            { title: "Mit", name: "<a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/monawyss/'>Mona Lou Wyss</a><br><a target='_blank' rel='noopener noreferrer' href='https://www.eva-welter.ch/'>Eva Welter</a><br><br>" },
            { title: "Regieassistenz", name: "<a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/deorrwine/'>Darwin Sam</a>" },
            { title: "Kameraassistenz", name: "<a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/lukasfilm_ltd/'>Lukas Mörsch</a>" },
            { title: "Production Design", name: "<a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/alvamatter/'>Alva Matter</a><br><a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/naadiiaa.a/'>Nadia Klauser</a>" },
            { title: "Oberbeleuchter", name: "<a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/cedric.kalt/'>Cedric Kalt</a>" },
            { title: "Beleuchter", name: "<a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/ppapalreppap/'>Silvio Meessen</a>" },
            { title: "Hair & Makeup", name: "<a target='_blank' rel='noopener noreferrer' href=''>Jimena Zbinden</a><br><br>" },
            { title: "Grading", name: "<a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/cedric.kalt/'>Cedric Kalt</a>" },
            { title: "Sound Design", name: "<a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/lalo._s/'>Leandro Scherler</a><br><a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/luhgaa/'>Luca Schär</a><br><br>" },
            { title: "Statist:innen", name: "Leandro Scherler<br>Désirée Gallo<br>Michael Altorfer<br>Luca Schär<br>Gisela Balmer<br>Lisa Caginari<br>Christian Busch<br>Alexandra Busch<br>Natasja de Jong-Van Roy<br>Claire-Lise Godel<br><br>" },
            { title: "Equipment", name: "Octamas, Cinelight, zumirent, ZHdK, Mischa Müller, Elia Grunder, Silvio Meessen, Cedric Kalt, Lukas Mörsch, Maurice Busch, Jonas Kunz" },
            { title: "Location", name: "<a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/allianzaambulanza/'>Allianza Ambulanza</a><br><br>" },
            { title: "BTS", name: "<a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/lemi.on/'>Lemi Onurtekin</a><br><a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/noaahxo/'>Noah Bill</a><br><br>" },
            { title: "Gefördert von", name: "<a target='_blank' rel='noopener noreferrer' href='https://startstutz.ch/'>Startstutz</a>" }
          ],
          path: "wohnig",
          video: "https://www.youtube-nocookie.com/embed/3LJ49EhW74E?si=2OrHaHPA88DO5IOa",
          description: 'Für die zweite Single "WOHNIG" der Berner Band Motelpool durfte ich das Musikvideo konzipieren und als Regie umsetzen. Merci an das Ganze Team, die das möglich gemacht haben.'
        },
        {
          image: skImg,
          title: "Soukey Festivalsommer",
          year: 2025,
          type: "Dokumentarisch",
          by: "von Jonas Kunz & Maurice Busch",
          myroll: "Regie, Schnitt & 2. Kamera",
          rolls: [
            { title: "Regie, Schnitt & 2. Kamera:", name: "<a href='/about'><hl>Jonas Kunz</hl></a>" },
            { title: "Kamera, Schnitt & Colorgrading:", name: "<a target='_blank' rel='noopener noreferrer' href='https://mauricebusch.ch'>Maurice Busch<a><br><br>" },
            { title: "Mit:", name: "<a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/s0ukey/'>Soukey</a><br>Lou<br><a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/humudrums/'>Humu</a><br><a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/michel_demello/'>Michel</a><br><br>" },
            { title: "Und:", name: "<a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/younoobtoo/'>Timo</a><br><a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/holyfuck.artbabe/'>Devi</a><br><a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/ama.faire/'>Anna</a><br><a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/ilanas_spektakel/'>Ilana</a><br><a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/zthefreshman/'>Yannis</a><br><a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/sally.sar.a/'>Sally</a><br><a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/selimaxmaya/'>Maya</a><br><a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/loundleduc/'>Leduc</a><br><br>" },
            { title: "Sound Design & Score:", name: "<a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/lalo._s/'>Leandro Scherler<a>" },
            { title: "Grafik:", name: "<a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/faulty.flowers/'>Jay - faulty.flowers<a>" },
            { title: "Administrative Unterstützung:", name: "<a target='_blank' rel='noopener noreferrer' href='https://pferd.rodeo/'>Büro Pferd<a><br><br>" },
          ],
          path: "soukey-festivalsommer-2025",
          video: "https://www.youtube-nocookie.com/embed/HprAO43NAwI?si=jxG23WpH7MbnS5yk",
          description: 'Im Sommer 2025, durfte ich Soukey und ihr Team auf ihrer "Bijoux" Festivaltour durch die Schweiz begleiten.',


        },
        {
          image: nkImg,
          title: "Nachklang",
          year: 2025,
          type: "Fiktional",
          by: "von Jonas Kunz",
          myroll: "Drehbuch, Regie & Schnitt",
          rolls: [
            { title: "Drehbuch, Regie & Schnitt:", name: "<a href='/about'><hl>Jonas Kunz</hl></a><br><br>" },
            { title: "Hauptbesetzung:", name: "<a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/call.in.vemba/'>Colin Vemba<a><br><a target='_blank' href='https://www.instagram.com/julineandresen/'>Juline Andresen<a><br><br>" },
            { title: "Kamera:", name: "<a target='_blank' rel='noopener noreferrer' href='https://mauricebusch.ch'>Maurice Busch<a><br><br>" },
            { title: "Musikkomposition & Sounddesign:", name: "<a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/lalo._s/'>Leandro Scherler<a><br><br>" },
            { title: "Regieassistent:", name: "<a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/miller.mischa/'>Mischa Miller<a>" },
            { title: "Kameraassistent:", name: "<a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/tinokistler/'>Tino Kistler</a>" },
            { title: "Tonassistent:", name: "<a target='_blank' rel='noopener noreferrer' href='https://jannyffenegger.ch'>Jan Nyffenegger</a><br><br>" },
            { title: "Maskenbildnerin:", name: "<a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/lara.zahnd'>Lara Zahnd</a><br><br>" },
            { title: "Catering:", name: "Lara Kunz<br> Sandra Zaugg Kunz<br> Daniel Kunz<br><br>" },
            { title: "BTS Fotografie:", name: "<a target='_blank' rel='noopener noreferrer' href='https://www.instagram.com/capturedby_luana/'>Luana Truninger</a><br><br>" },
            { title: "Danke an:", name: "Michael<br>Nico<br>Noelle<br>Tino<br>zumirent<br>Lorena Tappert" },

          ],
          video: "https://www.youtube-nocookie.com/embed/-zwv_Hl7kZU?si=1RA89yq7F8QISy6d",
          path: "nachklang",
          description: 'Nachdem Henri in der Vornacht zusammengeschlagen wurde, sitzt er zusammen mit seiner Freundin Lura, ein paar hundert Kilometer von Zuhause, bei ihr in Deutschland am Frühstückstisch.  Der anstehende Abschied macht es den Beiden nicht einfach. Im Verlauf des Gesprächs stellt sich Henri seiner Mentalen Verfassung und seinem Umgang mit der Situation.',
        },
        {
          image: mnImg,
          title: "Mini Nachbere",
          year: 2024,
          type: "Musikvideo",
          by: "von San Mattia",
          myroll: "Drehbuch, Regie & Schnitt",
          rolls: [
            { title: "Drehbuch, Regie & Schnitt:", name: "<a href='/about'><hl>Jonas Kunz</hl></a>" },
            { title: "DoP:", name: "<a target='_blank' href='https://mauricebusch.ch'>Maurice Busch<a>" },
            { title: "AC:", name: "<a target='_blank' href='https://www.instagram.com/tinokistler/'>Tino Kistler</a>" },
            { title: "Sound & Title Font:", name: "Dan Mattia Mueri <br><br>" },
            { title: "Special Thanks:", name: "Chistian, Fabio & Startstutz" },
          ],
          description: 'Für den Berner Mundardmusiker san mattia habe ich das Musikvideo zu seiner Single "Mini Nachbere" geschrieben und Regie geführt. ',
          path: "mini-nachbere",
          video: "https://www.youtube-nocookie.com/embed/owPhi2NvCxk?si=UTjI_-CAk5DINcuY"
        },
        {
          image: kdImg,
          title: "Khodor",
          year: 2025,
          type: "Dokumentarisch",
          by: "von Maurice Busch",
          myroll: "Schnittdramaturgie",
          description: "Beim Kurzdokumentarfilm von Maurice Busch, unterstützte ich ihn bei der Schnittdramaturgie.",
          rolls: [
            { title: "Regie, Kamera & Schnitt:", name: "<a target='_blank' href='https://mauricebusch.ch'>Maurice Busch<a><br><br>" },
            { title: "Mit:", name: "Khodor Bahmad<br><br>" },
            { title: "Musik:", name: "<a target='_blank' href='https://larsfolgner.com'>Lars Folgner</a><br><br>" },
            { title: "Mitwirkung Schnittdramaturgie:", name: "<a href='/about'><hl>Jonas Kunz</hl></a><br><br>" },
            { title: "Interview Dreh Unterstützung:", name: "<a target='_blank' href='http://chiaraloetscher.ch/'>Chiara Lötscher</a><br><a target='_blank's href='https://www.instagram.com/tinokistler/'>Tino Kistler</hl></a><br><a href='/about'><hl>Jonas Kunz</hl></a>" },
          ],
          path: "khodor",
          video: "https://www.youtube-nocookie.com/embed/o3xS2IDjt2s?si=oU90cxtx2TKP6rR9  "
        },
        {
          image: EgauImg,
          title: "Egau",
          year: 2022,
          by: "von Jule X & Nicky B Fly",
          type: "Musikvideo",
          myroll: "Regie & Schnitt",
          rolls: [
            { title: "Regie & Schnitt:", name: "<a href='/about'><hl>Jonas Kunz</hl></a>" },
            { title: "DoP & Colorist:", name: "Andrin Schranz" },
            { title: "Kamera:", name: "Cedric Ribi<br><br>" },
          ],
          path: "egau",
          video: "https://www.youtube-nocookie.com/embed/EE4Mr78Wh-E?si=2pzNjsBOX5H65Jm7"
        },
        {
          image: ozsImg,
          title: "Opps zu spät",
          year: 2024,
          by: "von Kante K",
          type: "Musikvideo",
          myroll: "Drehbuch, Regie & Schnitt",
          rolls: [
            { title: "Drehbuch, Regie & Schnitt:", name: "<a href='/about'><hl>Jonas Kunz</hl></a>" },
            { title: "Kamera:", name: "<a target='_blank' href='https://mauricebusch.ch/contact.html'>Maurice Busch<a><br><br>" },
            { title: "Mit:", name: "Lalo, Mikado & Felix Fuhrer" },
          ],
          description: 'Beim das Musikvideo zum Song "Opps zu spät" für KanteK, erstellte ich das Konzept und führte Regie.',
          path: "ozs-kantek",
          video: "https://www.youtube-nocookie.com/embed/L-keiyMw0mY?si=Q2p53X6a9VT1aiVI"
        },
       /*  {
          image: wmImg,
          title: "Workmed",
          year: 2024,
          type: "Kampagnen Video",
          by: "WorkMed AG",
          myroll: "1st AC & Grip",
          description: "Für ein Kampagnen Video für die Firma WorkMed AG, arbeitete ich an zwei Drehtagen als 1st AC und Grip.",
          rolls: [
            { title: "Regie & DoP:", name: "<a target='_blank' href='https://mauricebusch.ch/contact.html'>Maurice Busch<a>" },
            { title: "1st AC & Grip:", name: "Andrin Schranz,<br>Fabio Gaiardo,<br>Jan Nyffenegger,<br><a href='/about'><hl>Jonas Kunz</hl></a><br>Tino Kistler" },

          ],
          path: "workmed",
          video: "https://www.youtube-nocookie.com/embed/gLhcHm6cizY?si=NPTascMoTZTEcaWt"
        },*/
        {
          image: tbslImg,
          title: "The Bittersweet Life",
          year: 2023,
          by: "von Ocular",
          type: "Dokumentarisch",
          myroll: "Regie, Interview & Audio",
          rolls: [
            { title: "Mit:", name: "Ara Ko<br><br>" },
            { title: "Interview & Regie:", name: "<a href='/about'><hl>Jonas Kunz</hl></a>" },
            {
              title: "Kamera:",
              name: "Andrin Schranz & Cedric Ribi <br><br>"
            },
            { title: "Lead Schnitt:", name: "Cedric Ribi" },
            { title: "Farben & Animation:", name: "Andrin Schranz" },
            { title: "Audio & Sound Design", name: "<a href='/about'><hl>Jonas Kunz</hl></a>" }
          ],
          description: "Ara lebt seit ihrer Geburt in Seoul, Südkorea. In der Dokumentation «The Bittersweet Life» erzählt sie von ihrem Leben in der grössten Stadt Südkoreas. Das Leben in der Metropole bietet viele Chancen und Möglichkeiten, hat aber auch seine Schattenseiten. Ara spricht offen über ihr privates Leben, ihre Schwierigkeiten und wie sie das Leben in der Grossstadt meistert.",
          path: "tbsl",
          video: "https://www.youtube-nocookie.com/embed/MM9XUcJ1hBw?si=zD3VI3dlmserlZxX"
        },
        {
          image: chempaeImg,
          title: "chempä.",
          year: 2023,
          by: "von Ocular",
          type: "Fiktional",
          myroll: "Co-Regie, Schnitt & Colorist",
          rolls: [
            { title: "Mit:", name: "<a href='/about'><hl>Jonas Kunz</hl></a><br><br>" },
            { title: "Story:", name: "<a target='_blank' href='https://ocular.ch'>Ocular Collective<a>" },
            { title: "Regie, Schnitt & Colorist:", name: "<a href='/about'><hl>Jonas Kunz</hl></a>" },
            { title: "Cinematography:", name: "Andrin Schranz & Cedric Ribi" },
            { title: "PA:", name: "Luka Aeschlimann<br><br>" },
          ],
          path: "chempae",
          video: "https://www.youtube-nocookie.com/embed/rdOYQB_9wZ4?si=5DmdJQr5g8GrbLMe"
        },
        /*         {
                  image: sdImg,
                  title: "Slow Down!",
                  by: "von LocY",
                  type: "Musikvideo",
                  myroll: "Regie & Schnitt",
                  rolls: [
                    { title: "Regie & Schnitt:", name: "<a href='/about'><hl>Jonas Kunz</hl></a>" },
                    { title: "Co-Regie:", name: "LocY & Minako Bisang" },
                    { title: "DoP & Colorist:", name: "Andrin Schranz<br><br>" },
                    { title: "1st AC:", name: "<a target='_blank' href='https://www.instagram.com/noelgygax/'>Noël Gygax</a><br><br>" },
                    { title: "Animation:", name: "Minako Bisang & Ysabel Steiner" },
                    { title: "Makeup:", name: "Sarah Walker" },
                    { title: "PAs:", name: "Feride Saljmanaj, Jasmin Angelina & Minako Bisang" },
                    { title: "Styling:", name: "Reya Amalia" }
                  ],
                  path: "slow-down",
                  video: "https://www.youtube-nocookie.com/embed/3oSUMN9nUDw?si=ufxT7hL6aLAaWHtj"
        
                },
               {
                  image: friseImg,
                  title: "frisä",
                  by: "von Ocular",
                  type: "Kurzfilm",
                  myroll: "PA",
                  rolls: [
                    { title: "Mit:", name: "Luka Aeschlimann<br><br>" },
                    { title: "Regie:", name: "Ocular Collective" },
                    { title: "Cinematographie:", name: "Andrin Schranz & Cedric Ribi" },
                    { title: "PA:", name: "<a href='/about'><hl>Jonas Kunz</hl></a><br><br>" },
                    { title: "Schnitt & Colorist:", name: "Andrin Schranz" },
                  ],
                  path: "frisae",
                  video: "https://www.youtube-nocookie.com/embed/T3vn5nujkn8?si=FdnqdBZuF-Fb0KfS"
                },
                {
                  image: nzImg,
                  title: "Nüt Ztüe",
                  by: "von Jaru",
                  type: "Musikvideo",
                  myroll: "Regie & Schnitt",
                  rolls: [
                    { title: "Regie & Schnitt:", name: "<a href='/about'><hl>Jonas Kunz</hl></a>" },
                    { title: "Cinematographie:", name: "Andrin Schranz" },
                    { title: "PA:", name: "Luis Schneuwly" }
                  ],
                  path: "nz",
                  video: "https://www.youtube-nocookie.com/embed/a3eobSkWqfo?si=s7AbJDLqMFPTHJ2b"
                },
                {
                  image: NBImg,
                  title: "Nils Buri",
                  by: "von Ocular",
                  type: "Kurz Dokumentarfilm",
                  myroll: "Co-Regie",
                  rolls: [
                    { title: "Produktion:", name: "<a target='_blank' href='https://ocular.ch'>Ocular Collective<a>" }
                  ],
                  description: 'Nils Buri ist Rugbyspieler. Er spielt in der ersten Mannschaft von Bern und in der U20 der Schweizer Nationalmannschaft. Diese Mini-Dokumentation behandelt seine bisherige Karriere, aber auch seine Träume für die Zukunft.',
                  path: "nils-buri",
                  video: "https://www.youtube-nocookie.com/embed/URoZHHvk4NQ?si=Es8SieUxba2Wqojt"
                }*/
      ];
      commit('setProjects', initialProjects);
    },
    updateSelectedType({ commit }, type) {
      commit('setSelectedType', type);
    }
  },
  modules: {},
  computed: {
    selectedType: {
      get() {
        return this.$store.state.selectedType;
      },
      set(value) {
        this.$store.commit('setSelectedType', value);
      }
    }
  }
});
